/* ============
 * LanguageTransformer
 * ============
 *
 * The transformer for the language.
 */

import Transformer from './transformer';

export default class languageTransformer extends Transformer {

  static fetch(language) {
    return {
      id: language.id,
      name: language.name,
      nationality: language.nationality,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/language.js